import { Navigate, useOutlet } from 'react-router';
import { useAuthContext } from '../context';
import { HOME_PATH, REDIRECT_URL_KEY } from '@/constants/app';

export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated } = useAuthContext();

  const redirectUrl = new URLSearchParams(window.location.search).get(REDIRECT_URL_KEY);

  if (isAuthenticated) {
    if (redirectUrl && redirectUrl !== '') {
      return <Navigate to={redirectUrl} replace />;
    }
    return <Navigate to={HOME_PATH} replace />;
  }

  return <>{outlet}</>;
}
